/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Tickets_CreatingInputs */

const en_settings_tickets_creating = /** @type {(inputs: Settings_Tickets_CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submitting...`)
};

const zh_settings_tickets_creating = /** @type {(inputs: Settings_Tickets_CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提交中…`)
};

/**
* | output |
* | --- |
* | "Submitting..." |
*
* @param {Settings_Tickets_CreatingInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_tickets_creating = /** @type {((inputs?: Settings_Tickets_CreatingInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Tickets_CreatingInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_tickets_creating(inputs)
	return zh_settings_tickets_creating(inputs)
});
export { settings_tickets_creating as "settings.tickets.creating" }